export const TURNSTILE_SITE_KEY =
    process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY?.trim() ?? "";

export const CAPTCHA_REQUIRED_MESSAGE =
    "Please complete the spam protection check.";

export const CAPTCHA_VERIFICATION_FAILED_MESSAGE =
    "Spam protection verification failed. Please try again.";

export const isCaptchaEnabledOnClient = Boolean(TURNSTILE_SITE_KEY);
